import { ReactNode } from "react";
import type { Card } from "@memento/types/card";
import { canUseFeature, Feature } from "@memento/library/feature-access";
import { useSubscription } from "src/hooks/useSubscription";
import { LoadingStatus } from "src/libs/fetcher";
import { useFeatureFlags } from "src/contexts/FeatureFlagProvider";

type GuardCanUseFeatureProps = {
  feature: Feature;
  card?: Card;
  children: ReactNode;
};

// will only show children if user can use feature
export function GuardCanUseFeature({
  feature,
  card,
  children,
}: GuardCanUseFeatureProps) {
  const { featureFlags } = useFeatureFlags();
  const { status, subscription } = useSubscription();

  if (status !== LoadingStatus.SUCCESS) {
    return null;
  }

  const canUse = canUseFeature(feature, subscription, {
    card,
    featureFlags,
  });

  if (!canUse) {
    return null;
  }

  return <>{children}</>;
}
